function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.948 7.558a1.071 1.071 0 00-.915-.763l-5.773-.547L10.978.673A1.063 1.063 0 0010 0c-.426 0-.81.264-.977.674L6.74 6.248l-5.773.547c-.425.041-.783.34-.915.763a1.14 1.14 0 00.311 1.178l4.364 3.993-1.287 5.914c-.094.435.067.885.413 1.145.186.14.404.212.623.212.189 0 .376-.053.545-.158L10 16.736l4.977 3.106c.364.228.823.207 1.168-.053.346-.262.508-.712.413-1.146l-1.286-5.914 4.363-3.992c.321-.293.444-.756.312-1.18z",
  fill: "#879097"
});

function SvgIconFavourites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgIconFavourites;